import { render, staticRenderFns } from "./Sidebar2.vue?vue&type=template&id=2fd9b00e&scoped=true&"
import script from "./Sidebar2.vue?vue&type=script&lang=js&"
export * from "./Sidebar2.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar2.vue?vue&type=style&index=0&id=2fd9b00e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd9b00e",
  null
  
)

/* custom blocks */
import block0 from "./Sidebar2.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports